export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
  permission?: string
}
export default {
  root: { name: '/', displayName: 'navigationRoutes.home' },
  routes: [
    { name: 'dashboard', displayName: 'menu.dashboard', meta: { icon: 'vuestic-iconset-dashboard' } },
    { name: 'system-documents', displayName: 'Tài liệu hệ thống', meta: { icon: 'menu_book' }, permission: 'accounts.view' },
    {
      name: 'transaction-statistics',
      displayName: 'Thống kê giao dịch',
      meta: { icon: 'analytics' },
      permission: 'statistics.view',
    },
    {
      name: 'reconciliation-reports',
      displayName: 'Biên bản đối soát',
      meta: { icon: 'description' },
      permission: 'statistics.view',
    },
    {
      name: 'management',
      displayName: 'Quản lý',
      meta: { icon: 'settings' },
      children: [
        { name: 'accounts', displayName: 'Quản lý tài khoản', meta: { icon: 'manage_accounts' }, permission: 'accounts.view' },
        { name: 'permission-groups', displayName: 'Quản lý nhóm quyền', meta: { icon: 'groups' }, permission: 'permission_groups.view' },
        { name: 'dealers', displayName: 'menu.dealers', meta: { icon: 'business' }, permission: 'dealers.view' },
        { name: 'gift-combos', displayName: 'Quản lý combo và giá', meta: { icon: 'local_offer' }, permission: 'gift_combos.view' },
      ],
    },
    {
      name: 'transaction-import',
      displayName: 'menu.transactions',
      meta: { icon: 'receipt_long' },
      children: [
        { name: 'transaction-import', displayName: 'menu.transactionImport', meta: { icon: 'upload_file' }, permission: 'transactions.import' },
        { name: 'transaction-history', displayName: 'menu.transactionHistory', meta: { icon: 'history' }, permission: 'transactions.view' },
        { name: 'consolidated-transactions', displayName: 'menu.showroomTransactions', meta: { icon: 'table_view' }, permission: 'transactions.view' },
        { name: 'spent-point-transactions', displayName: 'Giao dịch tiêu điểm', meta: { icon: 'payments' }, permission: 'transactions.view' },
        { name: 'gift-transactions', displayName: 'menu.giftTransactions', meta: { icon: 'card_giftcard' }, permission: 'gift_combos.view' },
        { name: 'transaction-conflicts', displayName: 'menu.transactionConflicts', meta: { icon: 'rule' }, permission: 'conflicts.view' },
      ],
    },
    { name: 'transaction-audit-history', displayName: 'Lịch sử thao tác', meta: { icon: 'history' }, permission: 'audit.view' },
  ] as INavigationRoute[],
}
